import { apiService } from './api';
import type { PaginatedResponse, WaitingScreen, ScreenUploadRequest, ApiResponse, LLMTokenUsageResponse } from '../types';

class ScreenService {
  async getScreens(params: {
    page: number;
    limit: number;
    fromDate?: string;
    toDate?: string;
    nextToken?: string;
  }): Promise<PaginatedResponse<WaitingScreen>> {
    const queryParams = new URLSearchParams();
    queryParams.append('page', params.page.toString());
    queryParams.append('limit', params.limit.toString());

    if (params.fromDate) queryParams.append('fromDate', params.fromDate);
    if (params.toDate) queryParams.append('toDate', params.toDate);
    if (params.nextToken) queryParams.append('nextToken', params.nextToken);

    return apiService.get<PaginatedResponse<WaitingScreen>>(
      `/v1/admin/screens?${queryParams.toString()}`
    );
  }

  async uploadScreen(request: ScreenUploadRequest): Promise<ApiResponse<WaitingScreen>> {
    return apiService.post<ApiResponse<WaitingScreen>>('/v1/admin/screens', request);
  }

  async getScreenById(id: string): Promise<WaitingScreen> {
    return apiService.get<WaitingScreen>(`/v1/admin/screens/${id}`);
  }

  async deleteScreen(id: string): Promise<ApiResponse> {
    return apiService.delete<ApiResponse>(`/v1/admin/screens/${id}`);
  }

  async getStatistics(): Promise<{
    totalCount: number;
    latestScreenTime?: string;
  }> {
    return apiService.get<{
      totalCount: number;
      latestScreenTime?: string;
    }>('/v1/admin/screens/statistics');
  }

  // Individual statistics methods
  async getTotalScreensCount(): Promise<{ count: number }> {
    return apiService.get<{ count: number }>('/v1/admin/statistics/total-screens');
  }

  async getLatestScreenTime(): Promise<{ time: string | null }> {
    return apiService.get<{ time: string | null }>('/v1/admin/statistics/latest-screen-time');
  }

  async getLLMTokenUsage(): Promise<LLMTokenUsageResponse> {
    return apiService.get<LLMTokenUsageResponse>('/v1/admin/statistics/llm-token-usage');
  }
}

export const screenService = new ScreenService();